import React, { Component } from 'react';
import * as _ from 'lodash-es';
import parse from 'html-react-parser';
import { formatStorePrice as _formatStorePrice } from '../../../utils/ecommerce/currency.js';

class CoreLicense extends Component {
	constructor(props) {
		super(props);

		this.lineItem = this.props.lineItem;
		this.localizedKeys = this.props.localizedKeys;
		this.formattedLocale = this.props.formattedLocale;
		this.currency = this.props.currency;
		this.proceedToCheckoutError = this.props.proceedToCheckoutError;

		this.onAssignCoreLicenses = this.onAssignCoreLicenses.bind(this);
		this.onQuantityChange = this.onQuantityChange.bind(this);
		this.cancelAssignment = this.cancelAssignment.bind(this);
		this.formatStorePrice = this.formatStorePrice.bind(this);
		this.formatStoreDate = this.formatStoreDate.bind(this);

		const coreLicenses = {
			cart: _.filter(this.props.coreLicenses, { selectType: 'new' }) || [],
			entitled: _.filter(this.props.coreLicenses, { selectType: 'existing' }) || [],
		};

		_.remove(coreLicenses['cart'], (license) => license.deleted); // remove deleted items.

		const coreLicenseState = this.calculateLicensesAndPrice(coreLicenses);

		this.state = {
			coreLicenses: coreLicenses,
			totalLicensesAssigned: coreLicenseState.totalLicensesAssigned,
			totalLicensesUnAssigned: coreLicenseState.totalLicensesUnAssigned,
			itemTotalPrice: coreLicenseState.itemTotalPrice,
		};
	}

	componentWillReceiveProps(props) {
		const coreLicenses = {
			cart: _.filter(this.props.coreLicenses, { selectType: 'new' }) || [],
			entitled: _.filter(this.props.coreLicenses, { selectType: 'existing' }) || [],
		};

		_.remove(coreLicenses['cart'], (license) => license.deleted); // remove deleted items.

		this.lineItem = props.lineItem;
		const coreLicenseState = this.calculateLicensesAndPrice(this.state.coreLicenses);

		this.setState({
			coreLicenses: coreLicenses,
			totalLicensesAssigned: coreLicenseState.totalLicensesAssigned,
			totalLicensesUnAssigned: coreLicenseState.totalLicensesUnAssigned,
			itemTotalPrice: coreLicenseState.itemTotalPrice,
		});
	}

	onAssignCoreLicenses() {
		const assignedCartLicenses =
			this.state.coreLicenses.cart.length > 0 ? _.filter(this.state.coreLicenses.cart, (license) => license.assignedQty > 0) : [];
		const assignedEntitledLicenses =
			this.state.coreLicenses.entitled.length > 0 ? _.filter(this.state.coreLicenses.entitled, (license) => license.assignedQty > 0) : [];

		const assignedCoreLicenses = [];

		if (assignedCartLicenses.length > 0) {
			Array.prototype.push.apply(assignedCoreLicenses, assignedCartLicenses);
		}
		if (assignedEntitledLicenses.length > 0) {
			Array.prototype.push.apply(assignedCoreLicenses, assignedEntitledLicenses);
		}

		this.lineItem.metadata.subscriptions.selected = assignedCoreLicenses;
		this.lineItem.metadata.pricing.itemTotalPrice = this.state.itemTotalPrice;
		this.lineItem.subscriptionId = assignedCoreLicenses[0].subscriptionId;
		this.lineItem.endDate = assignedCoreLicenses[0].dates[0].endDate + 'T00:00:00.000Z';

		this.lineItem.price = this.roundToTwo(this.state.itemTotalPrice / this.lineItem.quantity);

		this.props.onAssignCoreLicenses(this.lineItem);
	}

	roundToTwo(num) {
		return +(Math.round(num + 'e+2') + 'e-2');
	}

	cancelAssignment() {
		this.props.onAssignCoreLicenses();
	}

	onQuantityChange(license, newQty) {
		newQty = parseInt(newQty);

		if (newQty > -1 && (this.state.totalLicensesUnAssigned > 0 || newQty === 0 || license.assignedQty > newQty)) {
			license.assignedQty = newQty;
			const coreLicenseState = this.calculateLicensesAndPrice(this.state.coreLicenses);

			this.setState({
				totalLicensesAssigned: coreLicenseState.totalLicensesAssigned,
				totalLicensesUnAssigned: coreLicenseState.totalLicensesUnAssigned,
				itemTotalPrice: coreLicenseState.itemTotalPrice,
			});
		}
	}

	calculateLicensesAndPrice(coreLicenses) {
		const totalLicensesAssigned = _.sumBy(coreLicenses['cart'], 'assignedQty') + _.sumBy(coreLicenses['entitled'], 'assignedQty');
		const totalLicensesUnAssigned = this.lineItem.quantity - totalLicensesAssigned;

		const totalCartLicensePrice = _.sumBy(coreLicenses['cart'], (license) => license.dates[0].price * license.assignedQty);
		const totalEntitledLicensePrice = _.sumBy(coreLicenses['entitled'], (license) => license.dates[0].price * license.assignedQty);

		return {
			totalLicensesAssigned: totalLicensesAssigned,
			totalLicensesUnAssigned: totalLicensesUnAssigned,
			itemTotalPrice: totalCartLicensePrice + totalEntitledLicensePrice,
		};
	}

	render() {
		const coreLicense = Object.keys(this.state.coreLicenses).map((licenseType, index) => {
			const coreLicenseItem = this.state.coreLicenses[licenseType].length > 0 && (
				<div key={index}>
					<div className="cartheader" key={index}>
						<div className="config-item header trailer-half">
							<div className="config-item-name"> {this.localizedKeys.coreLicensesLabel} </div>

							<div className="config-item-qty">{this.localizedKeys.licenseQuantityLabel}</div>
							<div className="config-item-subtotal">{this.localizedKeys.subTotalLabel}</div>
						</div>
					</div>
					{this.state.coreLicenses[licenseType].map((license, index) => {
						return (
							<div className="config-item listitems" key={index}>
								<div className="config-item-name">
									<p className="trailer-half">
										{license.productName}{' '}
										{licenseType === 'cart' && <span className="itemincart"> {this.localizedKeys.currentlyInCartLabel}</span>}{' '}
									</p>
									{license.subscriptionId && (
										<p className="trailer-0 configTitle">
											{' '}
											<span> {this.localizedKeys.subscriptionIdLabel} </span> {license.subscriptionId}{' '}
										</p>
									)}
									<p className="configTitle trailer-0">
										<span> {this.localizedKeys.availableLicensesLabel} </span> {license.availableQty}{' '}
									</p>
									<p className="configTitle">
										<span> {this.localizedKeys.expirelabel} </span> {this.formatStoreDate(license.dates[0].endDate, this.formattedLocale)}{' '}
									</p>
								</div>

								<div class="config-mobile-menu">
									<div>{this.localizedKeys.licenseQuantityLabel}</div>
									<div>{this.localizedKeys.subTotalLabel}</div>
								</div>

								<div className="config-item-qty ">
									<div className="qtyLoader left-aligned">
										<button
											className="prc__less-qty-btn"
											aria-label={Granite.I18n.get('Decrease quantity')}
											onClick={() => this.onQuantityChange(license, license.assignedQty - 1)}
											disabled={this.state.onQuantityChange}>
											<span className="prc__minus" data-click="handleQtyMinus">
												−
											</span>
										</button>
										<input
											data-product-qty={license.assignedQty}
											id={`cartQty${index}`}
											value={license.assignedQty}
											className="prc__qty"
											aria-label={Granite.I18n.get('Quantity')}
											onChange={(event) => this.onQuantityChange(license, event.target.value)}
											type="number"
											disabled={this.state.onQuantityChange}
										/>
										<button
											className="prc__plus-qty-btn"
											aria-label={Granite.I18n.get('Increase quantity')}
											onClick={() => this.onQuantityChange(license, license.assignedQty + 1)}
											disabled={license.assignedQty >= license.availableQty}>
											<span className="prc__plus" data-click="handleQtyPlus">
												+
											</span>
										</button>
									</div>
									<calcite-link class="font-size--2 removeButton" onClick={() => this.onQuantityChange(license, 0)}>
										{this.localizedKeys.clearLabel}
									</calcite-link>
								</div>

								<div className="config-item-subtotal">
									<span data-product-price={license.dates[0].price * license.assignedQty}>
										{this.formatStorePrice(license.dates[0].price * license.assignedQty, this.formattedLocale, this.currency)}
									</span>
								</div>
							</div>
						);
					})}
				</div>
			);

			return (
				<div>
					{this.state.coreLicenses[licenseType].length > 0 && licenseType === 'cart' && (
						<div className="leader-1">
							{' '}
							<p className="font-size--1 avenir-demi"> {this.localizedKeys.newCoreLicensesTitleLabel} </p>
						</div>
					)}
					{this.state.coreLicenses[licenseType].length > 0 && licenseType === 'entitled' && (
						<div className="leader-1">
							<p className="font-size--1 avenir-demi trailer-half leader-1"> {this.localizedKeys.existingCoreLicensesTitleLabel} </p>
							<p className="font-size--3 trailer-1 light-gray-text trailer-1">
								<div className="richtext-container">
									{this.localizedKeys.existingCoreLicensesHeaderMessage && parse(this.localizedKeys.existingCoreLicensesHeaderMessage)}
								</div>
							</p>
						</div>
					)}
					{coreLicenseItem}
				</div>
			);
		});

		return (
			<>
				<div className="richtext-container">{this.localizedKeys.coreLicensesHeaderMessage && parse(this.localizedKeys.coreLicensesHeaderMessage)}</div>
				<div>
					<p className="avemir-demi font-size--1 trailer-quarter">
						{' '}
						{this.localizedKeys.totalLicenseAssignedLabel}: {this.state.totalLicensesAssigned}{' '}
					</p>
					<p className="avemir-demi font-size--1 ">
						{' '}
						{this.localizedKeys.totalLicenseunAssignedLabel}:{' '}
						<span className={this.state.totalLicensesUnAssigned < 0 ? 'text-red' : ''}> {this.state.totalLicensesUnAssigned} </span>{' '}
					</p>
					<div>{coreLicense}</div>
					<p className="configTotal">
						<span> {this.localizedKeys.itemtotallabel} </span>{' '}
						{this.formatStorePrice(this.state.itemTotalPrice, this.formattedLocale, this.currency)}{' '}
					</p>
				</div>
				<div className="config-ctasection">
					<calcite-button class="font-size--2 margin-right--2" appearance="outline" onClick={() => this.cancelAssignment()}>
						{this.localizedKeys.cancelLabel}
					</calcite-button>
					<calcite-button scale="m" onClick={() => this.onAssignCoreLicenses()} disabled={this.state.totalLicensesUnAssigned !== 0 || undefined}>
						<div class="button-slotted-content">
							<span class="button-slotted-content__text">{this.localizedKeys.saveAssignmentLabel}</span>
							<calcite-icon class="button-slotted-content__icon margin-left--4 flip-rtl" scale="s" icon="arrow-right"></calcite-icon>
						</div>
					</calcite-button>
				</div>
			</>
		);
	}

	formatStorePrice(price, formattedLocale, currency) {
		return _formatStorePrice(price, formattedLocale, currency);
	}

	formatStoreDate(displayDate, formattedLocale) {
		const displayDateFormatted = new Date(displayDate);
		const dateOptions = {
			year: 'numeric',
			month: 'short',
			day: '2-digit',
			timeZone: 'UTC',
		};
		const locale = formattedLocale.split('_')[0] + '-' + formattedLocale.split('_')[1];

		return displayDateFormatted.toLocaleDateString(locale, dateOptions);
	}
}

export default CoreLicense;
